/* ------------------------------------------------------------------
お気に入りボタン、お気に入り済みの場合は「お気に入り中」に変更
--------------------------------------------------------------------- */
function initializeBookmarkBtn() {
  if (document.querySelector(".jsBookmark")) {
    $.ajax({
      url: Routes.async_info_bookmark_path(),
      type: "GET",
      dataType: "json",
      success(data) {
        const bookmarking_ids = data.person_signed_in
          ? data.bookmarking_ids
          : Cookies.getJSON("bookmark_articles_ids");
        (bookmarking_ids || []).forEach((article_id) => {
          $(`.jsBookmark[data-id=${article_id}]`).addClass("isAdded");
        });
      },
      error(_XMLHttpRequest, _textStatus, _errorThrown) {
        console.log("error");
      },
    });
  }
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeBookmarkBtn;
